const timesheetReportServiceName = "/TimesheetReport";

export function timesheetReportingService(http) {
    return {      
        getMonthlyTimesheetReportAsync: async (check, personnelCode, month, year)  => {    
            let timesheetParam = {
                Check: check,
                PersonnelCode: personnelCode,
                Month: month,
                Year: year
            }
            return await http.post(timesheetReportServiceName + "/GetPersonnelReportInformation", timesheetParam);
        },
        getPersonnelWorkListAsync: async (check, personnelCode, month, year)  => {
            let timesheetParam = {
                Check: check,
                PersonnelCode: personnelCode,
                Month: month,
                Year: year
            }
            return await http.post(timesheetReportServiceName + "/GetPersonnelWorkListAsync", timesheetParam);
        },
        getPersonnelMonthlySummationAsync: async (personnelCode, month, year)  => {    
            let timesheetParam = {
                PersonnelCode: personnelCode,
                Month: month,
                Year: year
            }
            return await http.post(timesheetReportServiceName + "/GetPersonnelMonthlySummationAsync", timesheetParam);
        },
        getPersonnelMissionVacationSummary: async (personnelCode, month, year)  => {    
            let timesheetParam = {
                PersonnelCode: personnelCode,
                Month: month,
                Year: year
            }
            return await http.post(timesheetReportServiceName + "/GetPersonnelMissionVacationSummary", timesheetParam);
        }
    }
    
}